var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _line, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrCodePlaceHolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 347,
    height: 499,
    viewBox: "0 0 347 499",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M210.662 355.288H129.94C125.529 355.288 122 351.759 122 347.348V327.94C122 323.529 125.529 320 129.94 320H210.662C215.073 320 218.602 323.529 218.602 327.94V347.348C218.602 351.318 215.073 355.288 210.662 355.288Z",
    stroke: "white",
    strokeWidth: 5.37725,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M170.08 446.156C155.965 446.156 144.496 434.687 144.496 420.572V355.288H195.223V420.572C195.664 434.687 184.195 446.156 170.08 446.156Z",
    stroke: "white",
    strokeWidth: 5.37725,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M274.181 464.241H234.481C225.659 464.241 218.602 471.298 218.602 480.12C218.602 488.942 211.544 496 202.722 496H186.401C177.579 496 170.521 488.942 170.521 480.12V445.714",
    stroke: "white",
    strokeWidth: 5.37725,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M170.08 375.138V392.341",
    stroke: "white",
    strokeWidth: 5.37725,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M289 19.0919H327.184V57.2756",
    stroke: "#FFFBFB",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M289 335.184H327.184V297",
    stroke: "#FFFBFB",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2755 19.0919H19.0917V57.2756",
    stroke: "#FFFBFB",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2755 335.184H19.0917V297",
    stroke: "#FFFBFB",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 34.9849,
    y1: 172,
    x2: 299.985,
    y2: 171,
    stroke: "#2AD23B",
    strokeWidth: 8
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 66.1507,
    y: 61.741,
    width: 85.3377,
    height: 85.3377,
    stroke: "white",
    strokeWidth: 9.48197
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 89.8552,
    y: 85.4459,
    width: 37.9279,
    height: 37.9279,
    stroke: "white",
    strokeWidth: 9.48197
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 184.675,
    y: 61.741,
    width: 85.3377,
    height: 85.3377,
    stroke: "white",
    strokeWidth: 9.48197
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 208.38,
    y: 85.4459,
    width: 37.9279,
    height: 37.9279,
    stroke: "white",
    strokeWidth: 9.48197
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 66.1507,
    y: 194.489,
    width: 85.3377,
    height: 85.3377,
    stroke: "white",
    strokeWidth: 9.48197
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 89.8552,
    y: 218.193,
    width: 37.9279,
    height: 37.9279,
    stroke: "white",
    strokeWidth: 9.48197
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 211.741,
    y: 221.741,
    width: 30.518,
    height: 30.518,
    stroke: "white",
    strokeWidth: 9.48197
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 254.049,
    y: 197.489,
    width: 12.9639,
    height: 12.9639,
    stroke: "white",
    strokeWidth: 6
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 187.675,
    y: 197.489,
    width: 12.9639,
    height: 12.9639,
    stroke: "white",
    strokeWidth: 6
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 187.675,
    y: 263.862,
    width: 12.9639,
    height: 12.9639,
    stroke: "white",
    strokeWidth: 6
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 254.049,
    y: 263.862,
    width: 12.9639,
    height: 12.9639,
    stroke: "white",
    strokeWidth: 6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCodePlaceHolder);
export default __webpack_public_path__ + "static/media/qr-code-place-holder.f73bed0164fba5422ed510a281c49571.svg";
export { ForwardRef as ReactComponent };